export enum CustomerTypeSize {
    None = 'None',
    Small = 'Small',
    Large = 'Large',
}